<template>
  <div class="message-display">
    <img class="message-icon" :src="iconPath" alt="message-icon">
    <div class="message-description">
      <h2 class="message-description-title">
        {{ title }}
      </h2>
      <div class="message-text">
        <h4 class="message-subtitle">
          {{ text }}
        </h4>
        <p v-if="description">
          {{ description }}
        </p>
        <p v-if="errorCode" class="message-error">
          {{ errorText }} <span class="error-code">{{ errorCode }}</span>
        </p>
        <button type="button" class="message--button-back bouncy" @click="backToLobby">
          {{ backText }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MessageDisplay',
  props: {
    text: { type: String, required: true },
    backUrl: { type: String, default: '' },
    errorCode: { type: String, default: '' },
    description: { type: String, default: '' },
    title: { type: String, required: true },
    errorText: { type: String, default: '' },
    backText: { type: String, default: 'Go back' },
    icon: { type: String, required: true },
    languageCode: { type: String, default: 'EN' }
  },
  computed: { iconPath() { return require(`../../icons/${this.icon}`); } },
  methods: {
    backToLobby() {
      if(this.backUrl) return window.top.location.href = this.backUrl;
      window.top.history.back();
    }
  }
}
</script>



<style lang="scss" scoped>
.message-display {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-top: 10%;
  padding: 4% 0;
  background-color: white;

    .message-icon {
      height: 30%;
      width: 30%;
      max-height: 400px;
      max-width: 400px;
    }

    .message-description {
      display: flex;
      justify-content: center;
      flex-direction: column;
      max-width: 30%;
      margin-left: 60px;
      font-family: 'Roboto', sans-serif;
      font-size: 18px;
      color: black;

      .message-text {
        padding-left: 10px;
        font-size: 16px;

        .message-subtitle {
          margin-top: 0;
        }

        .message-error {
          font-weight: bold;
        }

        .error-code {
          font-weight: initial;
          color: red;
        }
      }

      .message--button-back {
        margin: 20px 0 20px 10px;
        width: 25%;
        min-width: 128px;
        max-width: 200px;
        padding: 0.3em 1.2em;
        border-radius: 2em;
        border: none;
        font-size: 18px;
        color: #FFF;
        background-color: #4eb5f1;
        text-align: center;
        transition: all 1s;

        &:hover {
          background-color:#4095c6;
          cursor: pointer;
        }
      }

      .bouncy {
        animation: bouncy 5s infinite linear;
        position: relative;
      }

      @keyframes bouncy {
        0% { top: 0em; }
        40% { top: 0em; }
        43% { top: -0.9em; }
        46% { top: 0em; }
        48% { top: -0.4em; }
        50% { top: 0em; }
        100% { top: 0em; }
      }
    }

    @media screen and (max-width: 1024px){
      flex-direction: column;
      text-align: center;

      .message-icon {
        align-self: center;
      }

      .message-description {
        margin: 0 1rem;
        max-width: 100%;

        .message-text {
          padding-left: 0;
        }

        .message--button-back {
          margin-left: 0;
          align-self: center;
        }
      }
    }
}
</style>
